import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule, Route } from "@angular/router";
import { Lookup } from "../core/models/lookup.model";

export const DefaultModules = [
    CommonModule,
    TranslateModule,
    RouterModule
];

export const availableLanguages = ["el", "en"];
export const availableLanguagesLookup: Array<Lookup> = [
    { id: "el", name: "Ελληνικά" },
    { id: "en", name: "English" }
];

// tslint:disable-next-line: class-name
export interface menuItem {
    routerLink?: string;
    iconClass?: string;
    text: string;
    sidebarMenuItem?: boolean;
    tooltip?: string;
    childs?: Array<menuItem>;
}

export enum SocketEvents {
    Connect = "connect",
    Disconnect = "disconnect",
    NewChatMessage = "chat/message",
    Authorize = "authorize",
    LogoutSockets = "logout",
    PostUpdated = "posts/update",
    NewPost = "posts/newpost",
    Notifications = "notifications/new",
    FriendRequest = "friend/request",
    Invitation = "invitation",
    UpcomingEvent = "upcoming/event",
    EventDateUpdated = "event/date-updated"
}